export const SUBMIT_REVIEW = `
  mutation SubmitReview($token: String!, $status: String!, $executionId: String!) {
    reviewBudget(reviewParams: { executionId: $executionId, token: $token, status: $status }) {
      element1
      element2
      element3
      element4
      executionId
      requestedBy
      reviewedBy
      status
      year
      budgets {
        _0
        _1
        _2
        _3
        _4
        _5
        _6
        _7
        _8
        _9
        _10
        _11
      }
    }
  }
`
